module.exports = __webpack_public_path__ + "img/c2.254713ae.png";